<div class="wrapper">
  <ng-content></ng-content>
  <div class="expander"></div>
  <i class="fa fa-chevron-up" *ngIf="sortDirection === 'asc'" ></i>
  <i class="fa fa-chevron-down" *ngIf="sortDirection === 'desc'"></i>
</div>

